/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { YookassaConfirmation } from "../../entities/yookassa/Confirmation";
import { z } from "zod/v4";

export const yookassaConfirmationSchema = z.object({
    "confirmation_url": z.optional(z.string()),
"return_url": z.optional(z.string()),
"type": z.optional(z.string())
    }) as unknown as z.ZodType<YookassaConfirmation>